import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const PaypalEmail = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  const handleDebouncedPaypalEmailInputChange = useDebouncedCallback(() =>
    trackInvoicingSettings('Paypal e-mail typed'),
  )

  return (
    <FormItem
      name="paymentMethods.paypalEmail"
      render={({ field: { onChange, ...rest } }) => (
        <Input
          {...rest}
          onChange={(event) => {
            onChange(event)
            handleDebouncedPaypalEmailInputChange()
          }}
          placeholder={t('settings.organization.external_invoice.payment_methods.paypal.placeholder')}
        />
      )}
    />
  )
}
